import Image from "next/image";
import { useTrans } from "src/utils/useTrans";

const PATH = "/images/tactsuit/tactglove";

const data = [
  {
    description: "Put on the inner gloves first.",
    src: `${PATH}/tactglove-install-0.png`,
  },
  {
    description: "Put on the main gloves over the inner gloves.",
    src: `${PATH}/tactglove-install-1.png`,
  },
  {
    description:
      "After putting on the gloves, cross your fingers and press the fabric in between each finger to ensure that a motor is placed on each fingertip.",
    src: `${PATH}/tactglove-install-2.png`,
  },
  {
    description:
      "Fasten the device around your wrist by locking the magnetic strap.",
    src: `${PATH}/tactglove-install-3.png`,
  },
];

export default function TactGloveInstallation() {
  const { t } = useTrans(["tactsuit"]);

  return (
    <div className="flex max-w-screen-max flex-col justify-center">
      <h1 className="text-center text-2xl laptop:py-6 laptop:text-start">
        {t("How to Put on TactGlove")}
      </h1>
      <div className="mt-5 grid max-w-[1190px] grid-cols-2 justify-between gap-8 laptop:flex">
        {data.map((step, index) => (
          <div key={step.src} className="flex w-full max-w-[243px] flex-col">
            <div className={"relative flex h-[154px] w-full laptop:h-[240px]"}>
              <Image
                src={step.src}
                alt={step.description}
                className="object-contain"
                fill
              />
            </div>
            <p className="mb-1 font-600">Step {index + 1}</p>
            <p className={`text-sm`}>{t(step.description)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
